module.exports = __webpack_public_path__ + "static/media/fuzex.fdd2bd68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fuzex.svg
// module id = 103
// module chunks = 0